
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ChecklistFieldModule from '@/components/views/productView/ChecklistFieldModule.vue';
import ChecklistSegment from '@/models/ChecklistSegment';
import { ActiveProductFormValueObject } from '@/interfaces/general/ActiveProductFormValueObject';
import Offer from '@/models/Offer';
import { filterProductsFromOfferItems } from '@/helpers/OfferItemTableHelper';
import OfferItem from '@/models/OfferItem';
import OfferTitle from '@/models/OfferTitle';
import { TransformedTableOfferItem } from '@/interfaces/components/ProductsInOffer/TransformedTableOfferItem';

@Component({
    name: 'ChecklistSegmentModule',
    components: { ChecklistFieldModule },
})
export default class ChecklistSegmentModule extends Vue {
    @Prop({ required: true })
    private productFormValues!: ActiveProductFormValueObject | null;
    @Prop({ required: true }) private checklistSegment!: ChecklistSegment;
    @Prop({ required: true }) private activeProductFormId!: number | null;
    @Prop({ default: [] }) private pIdFieldErrors!: string[];
    @Prop({ default: 0 }) private levelOverride!: number;
    @Prop({ default: null }) private offer!: Offer;
    @Prop({ default: null }) private offerItem!: OfferItem;
    @Prop({ default: null }) private currentProductForm!: any;
    @Prop({ default: false }) private isConfigurator!: boolean;
    @Prop({ default: false }) private noSegments!: boolean;
    @Prop({ default: [] }) private temporaryDisabledPIDs!: string[];
    @Prop({ required: false, default: false }) private productDetails!: any;

    private connection: number | null = null;
    private level: number = 0;
    private production = true;
    private vodilaSegmentId: string = '9483';

    public switchLevel(level: number) {
        this.level = level;
    }

    @Watch('levelOverride', {
        immediate: true,
    })
    private overrideLevel(newVal: number, oldVal: number): void {
        this.level = newVal;
    }

    private get filteredChecklistFields() {
        return this.checklistSegment.checklistFields.filter((checklistField) => {
            return checklistField.fieldType !== 'abort' && checklistField.fieldType !== 'warning';
        });
    }

    private checklistFieldHasVisibilityFunction(checklistField: any) {
        return checklistField.checklistVisibleFunction != null;
    }

    private filterProductsFromOfferItems(offerItems: Array<OfferItem | OfferTitle | TransformedTableOfferItem>) {
        return filterProductsFromOfferItems(offerItems, false);
    }

    private resetLevel() {
        if (
            (this.isConfigurator &&
                this.$route.query.productSystemName === 'PENTO' &&
                this.checklistSegment.name === 'Vodila') ||
            this.checklistSegment.id === this.vodilaSegmentId
        ) {
            this.level = 0;
        }
    }

    private created() {
        if (this.offerItem) {
            this.connection = this.offerItem.connection;
            this.production = this.offerItem.production;
        }
    }

    private mounted() {
        this.resetLevel();
    }
}
